import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ForgetPasswordEnum } from "../_models";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  moduleId: module.id,
  templateUrl: "forgotpassword.component.html",
  styleUrls: ["forgotpassword.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  messages: any;
  uid: string;
  model: any = {};
  loading: boolean = false;
  loadingMail: boolean = false;
  loadingSms: boolean = false;
  changePassword: boolean = false;
  public ForgotPasswordSendEmail: boolean = false;
  isPasswordVisible: boolean = false;

  constructor(
    private router: Router,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private sessionManager: SessionManagerService
  ) {
    this.ForgotPasswordSendEmail =
      this.sessionManager.features.ForgotPasswordSendEmail;
  }

  // Add method to toggle password visibility
  toggleVisibility(event: MouseEvent) {
    event.preventDefault();
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  sendRequest() {
    const buttonName = document.activeElement.getAttribute("Name");

    this.loading = true;
    this.loadingMail = buttonName && buttonName == "email" ? true : false;
    this.loadingSms = buttonName && buttonName == "email" ? false : true;
    let postData = this.model;
    postData.type =
      buttonName && buttonName == "email"
        ? ForgetPasswordEnum.EMAIL
        : ForgetPasswordEnum.SMS;
    this.dataService.forgotPassword(postData).subscribe(
      (data) => {
        this.loading = false;
        this.loadingMail = false;
        this.loadingSms = false;
        this.model = {};
        this.alertService.success("נשלח בהצלחה", true);

        this.router.navigate(["/login"]);
      },
      (error) => {
        this.loading = false;
        this.loadingMail = false;
        this.loadingSms = false;
        let body = error.json && error.json();
        if (
          body &&
          body.statusText &&
          body.statusText.indexOf("no_user") >= 0
        ) {
          this.model = {};
          this.alertService.success("נשלח בהצלחה", true);
          this.router.navigate(["/login"]);
        } else {
          this.alertService.error(
            body && body.statusText
              ? this.messages && this.messages[body.statusText]
                ? this.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
        }
      }
    );
  }

  changePasswordFunc() {
    if (
      this.uid &&
      this.model &&
      this.model.password &&
      this.model.newPassword &&
      this.model.password == this.model.newPassword
    ) {
      this.loading = true;
      this.dataService.changePassword(this.uid, this.model).subscribe(
        (data) => {
          this.loading = false;
          this.model = {};
          this.alertService.success("נשלח בהצלחה", true);

          this.router.navigate(["/login"]).then();
        },
        (error) => {
          this.loading = false;
          this.alertService.error(
            error && error.statusText
              ? decodeURIComponent(error.statusText)
              : error
          );
        }
      );
    }
  }

  ngOnInit() {
    this.dataService.messages.subscribe((nextVal) => {
      this.messages = nextVal;
    });
    this.activatedRoute.params.subscribe((params) => {
      this.uid = params["uid"];

      if (this.uid && this.uid != "") {
        this.loading = true;
        this.dataService.getForgotPasswordData(this.uid).subscribe(
          (data) => {
            this.loading = false;
            this.changePassword = true;
          },
          (error) => {
            this.loading = false;
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forgotpassword/forgotpassword.component.ts